<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    // Using shorthand syntax...
    layout: WebLayout,
}
</script>
<script setup>
import SEOHead from '@/components/SEOHead.vue'
</script>

<template>
    <SEOHead
        title="O nas - Kulfood"
        description="Spoznajte našo zgodbo in vrednote. Kulfood ponuja okusne, hranljive in lahkotne obroke, ki vas napolnijo z energijo za vaš dan."
        keywords="o nas, Kulfood.si, vizija, misija, naša vizija, naša misija, naša zgodba, vrednote"
        canonical="/o-nas"
        :structured-data="{
            '@type': 'WebSite',
            'name': 'Kulfood.si',
            'url': 'https://kulfood.si',
            'description': 'Spoznajte našo zgodbo in vrednote. Kulfood ponuja okusne, hranljive in lahkotne obroke, ki vas napolnijo z energijo za vaš dan.',
        }"
        type="website"
    />
    <div class="container mx-auto px-4 py-12">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-4xl font-bold text-gray-900 mb-8 text-center">O NAS</h1>
            <section>
                <p class="text-iron-grey">
                    Ideja za Kulfood se je rodila iz naše lastne izkušnje. Med napornimi delovniki smo iskali obroke, ki bi nas nasitili, a nam hkrati dali pravi zagon za preostanek dneva. Iskali smo tisto popolno ravnovesje – nekaj okusnega in hranljivega, a brez tistega "težkega občutka" in utrujenosti, ki ju pogosto pusti klasično kosilo.
                </p>
            </section>
            <br>
            <section>
                <h2 class="text-2xl font-bold text-gray-900 mb-4">Strokovnost, ki jo začutite takoj</h2>
                <p class="text-iron-grey">
                    Kot certificiran prehranski svetovalec sem v razvoj vsakega recepta vložil strokovno znanje o metabolizmu in hranilnih vrednostih. Pri Kulfoodu ne gre le za hrano; gre za skrbno načrtovano gorivo, ki vašemu telesu instantno zagotovi vse, kar potrebuje za optimalno delovanje: optimalno količino beljakovin, ki poskrbijo za dolgotrajno sitost in regeneracijo, ogljikove hidrate, ki zagotavljajo stabilno energijo brez nenadnih padcev koncentracije, in bogat nabor vitaminov in mineralov, ki so ključni za vašo odpornost in sijoče počutje.
                </p>
            </section>
            <br>
            <section>
                <h2 class="text-2xl font-bold text-gray-900 mb-4">Mi načrtujemo, vi uživate v rezultatih</h2>
                <p class="text-iron-grey">
                    V današnjem hitrem tempu je čas največji luksuz, zdravje pa največja vrednota. Zavedamo se, da nimate časa za naporno načrtovanje jedilnikov, preučevanje deklaracij ali zapleteno računanje makrohranil. Vse to smo naredili namesto vas. Z izbiro Kulfood obroka naredite velik korak k bolj zdravemu načinu življenja in to popolnoma brez truda, razmišljanja ali organizacije. Odstranili smo stres, ki ga prinaša vprašanje "kaj je dobro zame?", in vam ponudili gotov odgovor na krožniku.
                </p>
            </section>
            <br>
            <section>
                <p class="text-iron-grey">
                    Z vsakim našim obrokom ste pravkar naredili nekaj izjemno dobrega zase. Naš cilj je preprost: želimo vam podariti vrhunski okus, svežino in tisti takojšen občutek lahkotnosti in dobre volje, ki vas bo spremljal skozi ves dan.
                </p>
                <p class="text-iron-grey">
                    Naročite Kulfood in si privoščite obrok, ki poskrbi za vas!
                </p>
                <div class="mt-6 flex justify-center">
                    <img src="/images/web/certifikat.png" alt="Certifikat prehranskega svetovalca" class="max-w-full h-auto rounded-lg shadow-md">
                </div>
            </section>
        </div>
    </div>
</template>
